<template>
	
	<div>
 
    <!-- 封装弹框 -->
		<el-dialog
                :visible.sync="idDialogVisible" :before-close="handleClose" :width="customWidth"  class="mydialog-1" >
            <slot>
              <el-tabs v-model="activeIndex" @tab-click="handleTabClick" type="card">
                <el-tab-pane label="회원정보" name="tab1">
                  <el-form ref="form" :model="form" label-width="100px" v-loading="formLoading">
              <table class="table table-bordered myTable ">
                <tr>
                  <td width="50%">
                   
                     <el-form-item label="아이디:" class="mb-0  formItem">
                  {{form.mem_id}}<span class="ml-2">{{form.id_txt}}</span><el-button type="primary" size="mini" class="ml-2" plain @click="add" style="padding:5px 8px">쪽지</el-button><el-button type="primary" size="mini" class="ml-2" @click="memModel" style="padding:5px 8px">충환전</el-button>
                  <el-button v-if="form.sitetype==3 || form.sitetype==2 " type="primary" size="mini" class="ml-2" plain @click="addRcom"  style="padding:5px 8px">추천</el-button>
                </el-form-item>
            
                  </td>
                  <td>
                     <el-form-item label="등급:" class="mb-0 formItem">
                   <el-select placeholder="선택" v-model="form.memState" size="mini" style="width:80px;" class="mr-2">
                      <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <span style="color:#999">상태:</span>
                  <el-select placeholder="선택" v-model="form.mem_status" size="mini" style="width:80px" class="ml-2">
                    <el-option
                    v-for="item in statusoptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                  </el-select>

                  </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="게임머니:" class="mb-0 formItem">
                   <span class="mr-2 text-danger">{{formatMoney(form.mem_cash)}}</span> 이벤트:<span class="ml-2 mr-2 text-primary">{{formatMoney(form.mem_eventmoney)}}</span>
                   <template v-if="form.sitetype==='3'">
                   롤링:<span class="text-success ml-2">{{formatMoney(form.mem_ing)}}</span></template>
                  </el-form-item>
                  </td>
                  <td>
                    <el-form-item label="상위:" class="mb-0 formItem">
                     <span style="color:#999">부본</span> <span class="text-danger mr-2">{{form.b_code}}</span>  <span style="color:#999">총판</span> <span class="text-primary mr-2">{{form.a_code}}</span>
                      <template v-if="form.sitetype=='2' || form.sitetype=='3'"><span style="color:#999">추천인</span> {{form.m_cp}}</template>
                      <template v-if="form.sitetype=='1' || form.sitetype=='4'"><span style="color:#999">매장</span> {{form.c_code}}</template>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                      <el-form-item label="닉네임:" class="mb-0 formItem">
                      <el-input v-model="form.mem_name" class="w-75"></el-input>
                      <el-color-picker v-model="form.color" size="mini" class="ml-2"></el-color-picker>
                   </el-form-item>
                  </td>
                  <td>
                    <el-form-item label="가입코드:" class="mb-0  formItem">
                      {{form.reg_code}}  {{form.ref}} <span style="color:#999" class="ml-1">접속:</span><span class="ml-2">{{form.mem_email}}</span>
                   
                  </el-form-item>

                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item label="비번:" class="mb-0 formItem">
                  <el-input v-model="form.mem_pw" class="w-75"></el-input>
                </el-form-item>
                 
                  </td>
                  <td>
                    <el-form-item label="핸드폰:" class="mb-0 formItem">
                    <el-input v-model="form.mem_hp"></el-input>
                 </el-form-item>
                  </td>
                </tr>
                   <tr v-if="form.sitetype==='2' || form.sitetype==='3'">
                  <td colspan="2">
                     <el-form-item class="mb-0 formItem d-flex myflex">
                   
              <span>한국경마:</span><el-input v-model="form.event_pro"  style="width:40px; margin:0px 5px"></el-input>
              <span>한경삼복:</span><el-input v-model="form.event_sambok"  style="width:40px; margin:0px 5px"></el-input>
              <span>한경쌍승:</span><el-input v-model="form.event_sang"  style="width:40px; margin:0px 5px"></el-input>
                <span>한경복연:</span><el-input v-model="form.event_bokyeon"  style="width:40px;margin:0px 5px"></el-input>

                
                <span>일본경정:</span><el-input v-model="form.event_pro_boat"  style="width:40px; margin:0px 5px"></el-input>
                <span>경정삼복:</span><el-input v-model="form.event_boat_sambok"  style="width:40px;margin:0px 5px"></el-input>
               <span>일본경륜:</span><el-input v-model="form.event_pro_cycle"  style="width:40px; margin:0px 5px"></el-input>
                <span>경륜삼복:</span><el-input v-model="form.event_cycle_sambok"  style="width:40px; margin:0px 5px"></el-input>

                   
                  
                </el-form-item>
                 
                  </td>
                 
                </tr>
                 <tr v-if="form.sitetype==='2' || form.sitetype==='3'">
                  <td colspan="2">
                     <el-form-item class="mb-0 formItem d-flex myflex">
                 

                 <span>일본경마:</span><el-input v-model="form.event_pro_japan"  style="width:40px; margin:0px 5px"></el-input>
                   <span>일경삼복:</span><el-input v-model="form.event_japan_sambok"  style="width:40px; margin:0px 5px"></el-input>
                   <span>일경삼쌍:</span><el-input v-model="form.event_japan_samsang"  style="width:40px; margin:0px 5px"></el-input>
                   
                  
                </el-form-item>
                 
                  </td>
                 
                </tr>
                 <tr v-if="form.sitetype==='1' || form.sitetype==='3'">
                  <td>
                     

                              <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code">
                               <el-form-item label="롤링:" class="mb-0 float-left formItem">
                                <span  class=" mr-2">일반:</span><el-input v-model="form.event_loing_recom" style="width:30px;" class="mr-2"></el-input>
                                <span  class="ml-2 mr-2">조합:</span><el-input v-model="form.event_loing_group_recom" style="width:30px;"></el-input> <span  class="ml-2 mr-2">사일 :</span><el-input v-model="form.event_loing_recom_s" style="width:30px;"></el-input><span  class="ml-2 mr-2">사조:</span><el-input v-model="form.event_loing_group_recom_s" style="width:30px;"></el-input>
                              </el-form-item>
                           
                            
                              
                            </template>

                              <template v-else="">
                               <el-form-item label="롤링:"  class="mb-0 float-left formItem">
                                <span  class="mr-2">일반:</span><el-input v-model="form.event_loing" style="width:30px;"></el-input>
                                <span class="ml-2 mr-2">조합:</span><el-input v-model="form.event_loing_group" style="width:30px;" ></el-input><span class="ml-2 mr-2">사일:</span><el-input v-model="form.event_loing_s" style="width:30px;"></el-input><span class="ml-2 mr-2">사조:</span><el-input v-model="form.event_loing_group_s" style="width:30px;"></el-input>
                              </el-form-item>
                              
                              </el-form-item>                                 
                                                       
                               </template>

                  
                  </td>
                  <td>
                    <template v-if="form.out_bet_sadari_g==='100' " >
                     <el-form-item label="바치기%:" class="mb-0 float-left formItem">
                                <span  class=" mr-2">일반:</span><el-input v-model="form.out_bet_power" style="width:40px;" class="mr-2"></el-input>
                                <span  class="ml-2 mr-2">조합:</span><el-input v-model="form.out_bet_power_g" style="width:40px;"></el-input> <span  class="ml-2 mr-2">사다리 :</span><el-input v-model="form.out_bet_sadari" style="width:40px;"></el-input>
                     </el-form-item>
                     </template>

                     <template v-if="form.bg==='1' " >

                      <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code">
                               <el-form-item label="보글롤링:" class="mb-0 float-left formItem">
                                <span  class=" mr-2">일반:</span><el-input v-model="form.event_loing_recom1" style="width:30px;" class="mr-2"></el-input>
                                <span  class="ml-2 mr-2">조합:</span><el-input v-model="form.event_loing_group_recom1" style="width:30px;"></el-input> <span  class="ml-2 mr-2">사일 :</span><el-input v-model="form.event_loing_recom_s1" style="width:30px;"></el-input><span  class="ml-2 mr-2">사조:</span><el-input v-model="form.event_loing_group_recom_s1" style="width:30px;"></el-input>
                              </el-form-item>
                           
                            
                              
                            </template>

                              <template v-else="">
                               <el-form-item label="보글롤링:"  class="mb-0 float-left formItem">
                                <span  class="mr-2">일반:</span><el-input v-model="form.event_loing1" style="width:30px;"></el-input>
                                <span class="ml-2 mr-2">조합:</span><el-input v-model="form.event_loing_group1" style="width:30px;" ></el-input><span class="ml-2 mr-2">사일:</span><el-input v-model="form.event_loing_s1" style="width:30px;"></el-input><span class="ml-2 mr-2">사조:</span><el-input v-model="form.event_loing_group_s1" style="width:30px;"></el-input>
                              </el-form-item>
                              
                              </el-form-item>                                 
                                                       
                               </template>
                                </template>
                  </td>
                  
                </tr>
                 <tr v-if="form.sitetype==='4'">
                  <td colspan="2">
                      <template v-if="form.mem_id===form.a_code || form.mem_id===form.b_code || form.mem_id===form.c_code">
                              <el-form-item label="바카라롤링:" class="mb-0 float-left formItem">
                              <el-input v-model="form.event_loing_recom_e" style="width:60px;" class="mr-2"></el-input>
                              <span style="color:#999" class="ml-2 mr-2">슬롯롤링:</span><el-input v-model="form.event_loing_recom_slot" style="width:50px;"></el-input>
                              </el-form-item>
                              
                            </template>

                              <template v-else="">
                               <el-form-item label="바카라롤링:"  class="mb-0 float-left formItem">
                                <el-input v-model="form.event_loing_e" style="width:60px;"></el-input>
                               
                                <span style="color:#999" class="ml-2 mr-2">슬롯롤링:</span><el-input v-model="form.event_loing_slot" style="width:50px;"></el-input>
                              </el-form-item>                             
                                                       
                               </template>
                  </td>
                  
                </tr>
                 <tr>
                  <td>
                     <el-form-item label="은행이름:" class="mb-0 formItem">
                  <el-input v-model="form.mem_bankcode" style="width:105px;"></el-input> <span style="color:#999" class="ml-2 mr-2">예금주:</span><el-input v-model="form.mem_bankname" style="width:105px;"></el-input>
                </el-form-item>
               
                  </td>
                  <td>
                     <el-form-item label="계좌번호:" class="mb-0 formItem">
                  <el-input v-model="form.mem_banknum"></el-input>
                </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item label="전용가상:" class="mb-0 formItem">
                      <el-input v-model="form.mem_zip" class="w-100"></el-input>
                    </el-form-item>

                  </td>
                  <td>
                    <el-form-item  label="생년월일:" class="mb-0 formItem">
                      <el-input v-model="form.mem_jumin"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr v-if="form.sitetype==='2' || form.sitetype==='3'">
                  <td>
                    <div class="d-flex">
                     <el-form-item label="배팅한도:" class="mb-0 formItem">
                            <el-input v-model="form.max_bet"></el-input>
                          </el-form-item>
                           <el-form-item v-if="form.sitetype==='2' || form.sitetype==='3'" label="딜레이:" class="mb-0 formItem">
                            <el-input v-model="form.t_delay"  style="width: 80px;"></el-input>
                          </el-form-item>
                    </div>
                  </td>
                  <td>
                     <el-form-item label="적중한도" class="mb-0 formItem">
                             <el-select placeholder="선택" v-model="form.m_emoney" size="mini">
                                  <el-option
                                  v-for="item in statusoptions2"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                                </el-select>
                          </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="가입일:" class="mb-0 formItem">
                     {{form.mem_regdate}}
                    </el-form-item> 
                  </td>
                  <td>
                     <el-form-item label="배팅차단:" class="mb-0 formItem">
                     <template v-if="form.sitetype==='1' || form.sitetype==='3'">파워<el-checkbox true-label="1" false-label="0" v-model="form.bet_black" style="margin-right:5px;"></el-checkbox></template>
                     
                     <template v-if="form.sitetype==='2' || form.sitetype==='3'"><span style="margin-top:0px;">한경</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black1" style="margin:0 5px;"></el-checkbox>
                     <span style="margin-top:0px;">일륜</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black2" style="margin:0 5px;"></el-checkbox>
                     <span style="margin-top:0px;">일정</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black3" style="margin:0 5px;"></el-checkbox>
                     <span style="margin-top:0px;">일경</span><el-checkbox true-label="1" false-label="0" v-model="form.bet_black4" style="margin:0 5px;"></el-checkbox></template>
                  </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item label="입금:" class="mb-0 formItem">
                     <span class="text-danger">{{formatMoney(form.in_money)}}</span> <span style="color:#999" class="ml-1">출금:</span><span class="ml-2 mr-2 text-primary">{{formatMoney(form.out_money)}}</span> <span style="color:#999">배팅:</span><span class="ml-2">{{formatMoney(form.mem_all_init)}}</span><el-button type="default" size="mini" style="padding:2px;" class="mr-1" icon="el-icon-refresh" @click="resetMoney(4)"></el-button>
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item label="로그인전머니:" class="mb-0 formItem">
                       {{formatMoney(form.reset_money)}}
                      </el-form-item>
                  </td>
                </tr>
                  <tr>
                  <td>
                      <el-form-item label="로그인회수:" class="mb-0 formItem">
                        {{form.mem_login}}  <span style="color:" class="ml-1">온라인:</span><span class="ml-2">{{form.loging}}</span><el-button type="default" size="mini" style="padding:2px;" class="ml-2 mr-2" icon="el-icon-refresh" @click="mlogout()"></el-button><span class="mr-2">중복로그인</span><el-select placeholder="선택" v-model="form.login_more" size="mini" style="width: 80px;">
                                  <el-option
                                  v-for="item in statusoptions3"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                                </el-select>
                      </el-form-item> 
                  </td>
                  <td>
                        <el-form-item label="가입IP:" class="mb-0 formItem">
                         {{form.mem_ip}} <span style="color:#999;" class="ml-1">최종IP:</span>{{form.logip}}
                        </el-form-item>
                  </td>
                </tr>
                  <tr>
                  <td>
                     <el-form-item label="마지막로그인:" class="mb-0 formItem">
                       {{form.mem_login_date}}
                      </el-form-item>      
                  </td>
                  <td>
                     <el-form-item label="마지막입금:" class="mb-0 formItem">
                       {{form.last_money_date}} <span style="color:#999;" class="ml-1">마지막출금:</span>{{form.last_out_money_date}}
                      </el-form-item>
                  </td>
                </tr>
                  <tr>
                  <td colspan="2">
                    <el-form-item label="메모:" class="mb-0 formItem">
                        <el-input
                          type="textarea"
                          :rows="4"
                          v-model="form.mem_memo">
                        </el-input>
                     
                      </el-form-item>
                  </td>
                 
                </tr>
                              </table>
      
   
  

          </el-form>
          <div class="d-flex" style="justify-content: right;">
               <el-button type="primary" @click="Save" :disabled="disabled">수정</el-button>
                <el-button @click="Cancel">Close</el-button>
          </div>

                </el-tab-pane>
                 <el-tab-pane label="로그인기록" name="tab2">
                  <el-table
                :data="tabList"
                style="width: 100%;margin-top: 40px;" v-loading="loading">

                <el-table-column
                  label="아이디" width="100" align="center" prop="mem_id">
                </el-table-column>
                  <el-table-column
                  label="아이피" align="center" prop="vIP">
                </el-table-column>

                 <el-table-column
                  label="주소" align="center" prop="vReferer">
                </el-table-column>

                <el-table-column align="center" prop="add_time" label="시간">
                </el-table-column>
               
              
              </el-table>
             
                 </el-tab-pane>
                  <el-tab-pane label="보유머니변동" name="tab3">
                      <el-table
                :data="tabList"
                style="width: 100%;margin-top: 40px;" v-loading="loading">
                <el-table-column
                  label="아이디" width=100 align="center" prop="mem_id">
                </el-table-column>

                  <el-table-column
                  label="변동금액" width=100 align="center" prop="money">
                </el-table-column>
               
                <el-table-column
                  prop="type" width=100 align="center"
                  label="구분">
                  
                </el-table-column>

                <el-table-column
                  prop="doc" align="center"
                  label="메모">
                  
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  label="시간">
                  
                </el-table-column>

                 
               
              
              </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="충전내역" name="tab4">
                      <el-table
                :data="tabList"
                style="width: 100%;margin-top: 40px;" v-loading="loading">
                <el-table-column
                  label="아이디" align="center" prop="io_id">
                </el-table-column>
                  <el-table-column
                  label="충전금액" align="center" prop="io_money">
                </el-table-column>
                <el-table-column
                  prop="io_regdate" align="center"
                  label="시간">
                  
                </el-table-column>
                
               
              
              </el-table>
                  </el-tab-pane>
                  <el-tab-pane label="환전내역" name="tab5">
                      <el-table
                :data="tabList"
                style="width: 100%;margin-top: 40px;" v-loading="loading">
                <el-table-column
                  label="아이디" align="center" prop="io_id">
                </el-table-column>
                  <el-table-column
                  label="환전금액" align="center" prop="io_money">
                </el-table-column>
                <el-table-column
                  prop="io_regdate" align="center"
                  label="시간">
                  
                </el-table-column>
                  
               
              
              </el-table>
                  </el-tab-pane>

                  <el-tab-pane label="알지급" name="tab6">
                      <el-table
                :data="tabList"
                style="width: 100%;margin-top: 40px;" v-loading="loading">
                <el-table-column
                  label="아이디" align="center" prop="mem_id">
                </el-table-column>
                  <el-table-column
                  label="금액" align="center" prop="money">
                </el-table-column>

                 <el-table-column
                  label="보낸 ID" align="center" prop="bet_id">
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  label="시간">
                  
                </el-table-column>
                  
               
              
              </el-table>
                  </el-tab-pane>

                   <el-tab-pane label="알회수" name="tab7">
                      <el-table
                :data="tabList"
                style="width: 100%;margin-top: 40px;" v-loading="loading">
                <el-table-column
                  label="아이디" align="center" prop="mem_id">
                </el-table-column>
                  <el-table-column
                  label="금액" align="center" prop="money">
                </el-table-column>

                 <el-table-column
                  label="받은 ID" align="center" prop="bet_id">
                </el-table-column>

                <el-table-column
                  prop="add_time" align="center"
                  label="시간">
                  
                </el-table-column>
               
              
              </el-table>
                  </el-tab-pane>

                   <el-tab-pane label="배팅내역" name="tab8">
                      <el-table
                :data="tabList"
                style="width: 100%;margin-top: 40px;" v-loading="loading">
               
                <el-table-column
                  label="게임사" align="center"  prop="provider_name">
                </el-table-column>
                 
                  <el-table-column
                  label="게임명"  align="center" prop="game_title">
                </el-table-column>
                

                <el-table-column
                  prop="round_id" align="center"
                  label="ROUND-ID">
                </el-table-column>

                 <el-table-column
                  prop="tx_type" align="center" width=30
                  label="구분">  
                </el-table-column>

                 <el-table-column
                  prop="bet" align="center" width=100
                  label="배팅">
                </el-table-column>
                <el-table-column
                  prop="win" align="center" width=100
                  label="당첨">
                </el-table-column>
                <el-table-column
                  prop="balance" align="center"
                  label="잔고">
                </el-table-column>
                <el-table-column
                  prop="create_at" align="center" width=70
                  label="일시">
                </el-table-column>
                <el-table-column
                  prop="txid" align="center"
                  label="상세">
                   <template slot-scope="scope">
        
                          <el-button type="danger" size="mini" @click="linkBtn">상세보기</el-button>
 
                  </template>
                </el-table-column>
              

                 
               
              
              </el-table>
                  </el-tab-pane>
                   
              </el-tabs>
              <div style="position:absolute; top: 95px;" v-if="tapId !=='0'">
      <el-form inline ref="form" :model="idsearchform" >
        
          <el-form-item  class="mb-0" style="margin-right:0">
             <el-date-picker
                  v-model="idsearchform.time"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="시작"
                  end-placeholder="마감" size="mini" class="mr-2" value-format="yyyy-MM-dd"style="width:200px" >
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="idsearchEvent">검색</el-button>  
          </el-form-item>
      </el-form>
       
    
    </div>
              <div v-if="tapId !=='0'" style="flex: 1;" class="px-2 mt-2">
                  <el-pagination
                  :current-page="idcurrentPage"
                  :page-sizes="[20,30,50,100]"
                  :page-size="idsize"
                  layout="sizes,prev, pager, next"
                  :total="idtotal"
                  @size-change="idhandleSizeChange"
                      @current-change="idhandleCurrentChange">
                </el-pagination>
                </div>
            </slot>
           
        </el-dialog>
        <el-dialog
            :visible.sync="dialogVisible" :width="memWidth" class="idModel" :close-on-click-modal ="false">
            <div class="border-bottom py-3"><span class="text-danger">{{this.form.mem_id}} ({{this.form.mem_name}})</span></div>
            <el-table
                :data="memIdData"
                style="width: 100%" v-loading="loading">
                <el-table-column
                  prop="date"
                  label="날자"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="inm"
                  label="입금">
                  <template slot-scope="scope">
                     {{formatMoney(scope.row.inm)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="outm"
                  label="출금">
                   <template slot-scope="scope">
                     {{formatMoney(scope.row.outm)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="inm"
                  label="차액">
                  <template slot-scope="scope">
                     <span :class="scope.row.inm - scope.row.outm <0 ?'text-danger':'text-primary'">{{formatMoney(scope.row.inm - scope.row.outm)}}</span>
                  </template>
                </el-table-column>
              
              </el-table>
  
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">Close</el-button>
        
            </span>
          </el-dialog>
          <el-dialog
        
          title="쪽지보내기" :width="customWidth"
          :close-on-click-modal ="false"
          :visible.sync="creatModel" style="height: 600px;overflow-y:auto ;">
           <div class="d-flex" v-loading="qaLoading">
          <div style="width:70%">
          <el-form ref="form" :model="memoform" label-width="100px" v-loading="loading" :rules="rules">
            
            <el-form-item label="아이디" class="mb-1">
              <el-input v-model="memoform.mem_id"></el-input>
            </el-form-item>
            <el-form-item label="레벨" class="mb-1">
              <div class="flexNo">
               <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">ALL</el-checkbox>
                  <div style="margin: 15px 0;clear:both;"></div>
                  <el-checkbox-group v-model="level" @change="handlelevelChange">
                    <el-checkbox v-for="checkboxs in cities" :label="checkboxs" :key="checkboxs">{{checkboxs}}</el-checkbox>
                  </el-checkbox-group>
                </div>
            </el-form-item>
           <el-form-item label="내용" prop="content" class="mb-1">
               <el-input
                type="textarea"
                :rows="8"
                v-model="memoform.content">
              </el-input>
          </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false" class="float-right">취소</el-button>
            <el-button type="primary" @click="memoSend()" class="float-right mr-2">확인</el-button>
          </span>
        </div>
        <div class="border ml-auto p-2 d-flex" style="width:25%;flex-direction:column;align-items:start">
            <el-button type="text" v-for="(item,index) in qa" :key="index"  class="py-2 ml-0" @click="qaChange(index)">{{item.title}}</el-button>
          
          </div>
      </div>
        
       
       
        </el-dialog>
          <el-dialog
          :width="memWidth"
          title="추천내역"
          :close-on-click-modal ="false"
          :visible.sync="reComModel" style="height: 600px;overflow-y:auto ;">
           <el-table
                :data="reComData"
                style="width: 100%" v-loading="loading">
                <el-table-column
                  prop="mem_id"
                  label="아이디(닉네임)"
                  width="180">
                   <template slot-scope="scope">{{scope.row.mem_id}}({{scope.row.mem_name}}) {{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}}</template>
                </el-table-column>
                
                <el-table-column
                  prop="mem_regdate"
                  label="가입일">
                  
                </el-table-column>
             
              </el-table>

         
          <span slot="footer" class="dialog-footer">
             <el-button @click="reComModel = false">닫기</el-button>
          
          </span>
        
       
       
        </el-dialog>
	</div>
</template>
<script>
const checkboxsOptions = ['0', '1', '2', '3', '4', '5', '6', '7'];


	export default{
		props:{
			
			visible: {
                type: Boolean,
                default: false
            },
			formLoading:{
				type: Boolean,
                default: false
			},
		
    formobject: {
        type: Object,
        default: () => {}
    },
   
		
		},
		computed: {
          
            idDialogVisible: {
                get() {
                    return this.visible
                },
            },
            
        },
    	data(){
    		return{
            modalFalse:false,
            idsearchform:{
            time:[],
          },
           pickerOptions: {
          },
          shortcuts: [{
            text: '최근한주',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근한달',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '최근3개월',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          idcurrentPage:1,
          idtotal:0,
          idsize:0,
          tabList:[],
          tapId:'0',
          activeIndex: 'tab1',
          memWidth:'500px',
          customWidth:'900px',
          reComModel:false,
         qaLoading:false,
          creatModel:false,
          checkAll: false,
          qa:[],
          reComData:[],
          level: [],
          cities: checkboxsOptions,
          isIndeterminate: true,
          domain:window.sessionStorage.getItem('domain'),
          memIdData:[],
          dialogVisible: false,
          disabled:false,
          loading:false,
          memoform:{
            mem_id:'',
            content:'',
          },
    			form:{
            login_more:'0',
            color:'',
            id_txt:'',
            bet_black:'',
            bet_black1:'',
            bet_black2:'',
            bet_black3:'',
            bet_black4:'',
            mem_name:'',
            mem_hp:'',
            mem_login:'',
            mem_id:'',
           

            mem_pw:'',
            mem_bankcode:'',
            mem_banknum: '',
            mem_bankname:'',
            mem_jumin:'',
            mem_zip:'',
            mem_regdate:'',
            mem_cash:'',
            mem_eventmoney:'',
            mem_ip:'',
            mem_raip:'',
            m_cp:'',
            mem_all_init:'',
            mem_memo:'',
            mem_status:'',
            m_emoney:'',
            loging:'',
            logip:'',
            mem_login_date:'',
            a_code:'',
            last_money_date:'',
            in_money:'',
            out_money:'',
            reset_money:'',

            event_loing:'',
            event_loing_recom:'',
            event_loing_group:'',
            event_loing_group_recom:'',
            event_loing_s:'',
            event_loing_recom_s:'',
            event_loing_group_s:'',
            event_loing_group_recom_s:'',


            event_loing1:'',
            event_loing_recom1:'',
            event_loing_group1:'',
            event_loing_group_recom1:'',
            event_loing_s1:'',
            event_loing_recom_s1:'',
            event_loing_group_s1:'',
            event_loing_group_recom_s1:'',



            event_boat_sambok: '',
            event_bokyeon: '',
            event_cycle_sambok: '',
            event_japan_sambok: '',
            event_japan_samsang: '',
            event_pro: '',
            event_pro_boat: '',
            event_pro_cycle: '',
            event_pro_japan: '',
            event_sambok: '',
            event_sang:'',


            event_loing_slot:'',
            event_loing_recom_slot:'',
            event_loing_e:'',
            event_loing_recom_e:'',

            last_out_money_date:'',
            reg_code:'',
            out_bet_power:'',
            out_bet_power_g:'',
            out_bet_sadari:'',
            out_bet_sadari_g:'',

           

            b_code:'',
        

          },
          urlLink:'https://blackstone-hk1.ppgames.net/gs2c/parentRoundHistoryDetails.do?playSessionId=10845692434823&stylename=blst_diamond2&hash=4d2fd93804bd9de97a2096e3317f719a&language=KO',
          level_title:{
              '-2':'블랙',
              '-1':'대기',
              '0':'기본'             
            },
            options: [{
              label: '블랙',
              value: '-2',
             
            }, {
              label: '대기',
               value: '-1',
              
            }, {
              label: '기본',
               value: '0',
             
            }, {
              label: 'v1',
               value: '1',
             
            }, {
              label: 'v2',
               value: '2',
             
            }, {
              label: 'v3',
               value: '3',
             
            }, {
              label: 'v4',
               value: '4',
             
            }, {
              label: 'v5',
               value: '5',
             
            }],
          memState:'',
          mem_status:'1',
          m_emoney:'',
          statusoptions: [{
              label: '정상',
              value: '1',
             
            },{
              label: '탈퇴',
               value: '0',
             
            }],
             statusoptions3: [{
              label: '금지',
              value: '0',
             
            },{
              label: '가능',
               value: '1',
             
            }],
            statusoptions2: [
            {
              label: '300만',
              value: '3000000',
             
            },
            {
              label: '500만',
              value: '5000000',
             
            },{
              label: '1000만',
               value: '10000000',
             
            },{
              label: '2000만',
               value: '20000000',
             
            }],
              rules: {
                  
                  content:[{ required: true, message: '', trigger: 'blur'}],
                },

    		
           
    			
    		}
    	},
      created() {
          

          
             
    },
    	methods:{
          handleTabClick(tab, event) {
              
              this.tapId=tab.index
              this.getTablist();   
      },
      idsearchEvent(){

        this.getTablist();
        },

         qaChange(index){
         
         
         
          this.memoform.content = this.qa[index].contents
 
        },
        addRcom(){
          this.reComModel = true
          this.loading = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                  method:'get',
                   url:this.domain+'/admin/mem?mem_id='+this.form.mem_id,
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
                   this.loading = false
                   let data = response.data.data
                   console.log('recom:',data.recom)
                   this.reComData = data.recom
                  
              
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据
            })
        },
        linkBtn(){
          window.open(this.urlLink,'_blank')
        },
        memoSend(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
          
             //添加提交
           
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/memo_send',
                        data:{
                          content:this.memoform.content,
                          mem_id:this.memoform.mem_id,
                          level:this.level,
                          
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                                message:response.data.msg,
                                type:'success'
                               });
                              
                            
                            this.creatModel = false

                            }
                           this.loading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
        
            })
              
            
        },
        add(){

             console.log('test')
             let token=window.sessionStorage.getItem('user');
             this.qaLoading = true
        
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/autoqalist',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 
             //console.log('data====',response.data.data)
                  let item = response.data.data.data 
                  //this.form.content=''
                  this.qa = item
                  this.memoform.content=''
                  this.memoform.mem_id=this.form.mem_id
                  this.qaLoading = false    
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
          this.creatModel = true

        },
         handleCheckAllChange(val) {
            this.level = val ? checkboxsOptions : [];
            this.isIndeterminate = false;
          },
          handlelevelChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
          },
        memModel(){
          this.getData()
          this.dialogVisible = true
          this.loading = true
        },
          getTablist(){
               let s_time="";
               let e_time="";

               let v=this.tapId;

               if(this.idsearchform.time.length>0)
               {
                  s_time=this.idsearchform.time[0];
                  e_time=this.idsearchform.time[1];
               }


            if(v=="0")
            {
               return;
            }
            this.loading = true
           let token=window.sessionStorage.getItem('user');
           let urls='';
           if(v=="1")
           {
              urls=this.domain+'/admin/acclist_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
           }else if(v=="2")
           {
              urls=this.domain+'/admin/moneylogs_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
           }else if(v=="3")
           {
             urls=this.domain+'/admin/moneylist_id?io_type=1&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
           }else if(v=="4")
           {
             urls=this.domain+'/admin/moneylist_id?io_type=2&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
           }else if(v=="5")
           {
             urls=this.domain+'/admin/moneylogs_id?type=10&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
           }else if(v=="6")
           {
             urls=this.domain+'/admin/moneylogs_id?type=11&mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time; 
           }else if(v=="7")
           {
             urls=this.domain+'/admin/apibetlist_id?mem_id='+this.form.mem_id+'&page='+this.idcurrentPage+'&s_time='+s_time+'&e_time='+e_time;
           }else
           {

           }
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     //console.log('tabdata=',response.data)
                     let data = response.data.data
                     this.idtotal = data.total
                     this.idcurrentPage = data.current_page
                     this.idsize =data.per_page
                     this.tabList =data.data
                     this.loading = false

                   
               
            }).catch((error) =>{
               this.loading = false
               
            })
        },
         idhandleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
               this.idsize = val
              this.getTablist();
              this.loading= true

            },
            idhandleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.idcurrentPage = val
              this.getTablist();
              this.loading= true
            },
        getData(){
           let token=window.sessionStorage.getItem('user');
           let urls=this.domain+'/admin/mem_by_inout_date?mem_id='+this.form.mem_id;
          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
            }).then((response) =>{ 

                      
                     console.log('data=',response.data)
                     let data = response.data.data
                     this.memIdData =data
                     let inmoney=0;
                     let outmoney=0;
                     data.map(function(item)
                     {
                        inmoney+=parseInt(item.inm)
                        outmoney+=parseInt(item.outm)
                     })

                     let total={date: "합계:", inm: inmoney, outm: outmoney};

                     this.memIdData.push(total);
                     this.loading = false

                   
               
            }).catch((error) =>{
              // if(error.response.status==401)
              // {
              //   this.$router.push({name:'login'})

              // }
                console.log('error',error.response)       //请求失败返回的数据
               
            })
        },

    		Cancel(){
    			this.$emit('cancelData')
    		},

    		// Save() {
      //           this.$emit('submitData')
      //       },
        Save(){
           this.$confirm('수정하시겠습니까?', '알림', {
          confirmButtonText: '수정',
          cancelButtonText: '취소',
          type: 'warning'
        }).then(() => {
          this.disabled = true
              this.$parent.formLoading  = true
              let token=window.sessionStorage.getItem('user');
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/mem_up',
                      data:this.form,   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{

                   // console.log('response',response);

                   if(response.data.code==200){
                       this.disabled = false
                       this.$parent.formLoading = false
                       this.$parent.idDialogVisible = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                      this.$parent.getList()   
                    }else
                    {
                      this.disabled = false
                      this.$parent.formLoading = false
                      // this.$parent.idDialogVisible = false
                      // this.idDialogVisible = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
         
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: '취소됨'
          });          
        });
              
     
        },

          resetMoney(type){
            let mtype='';
                     if(type==1)
                      {
                        mtype='게임머니';
                      }
                      else if(type==2)
                      {
                     
                       mtype='이벤트머니'; 
                        
                      }
                      else if(type==3)
                      {
                        mtype='롤링머니';
                      }
                      else if(type==4)
                      {
                        mtype='배팅누적';
                      }


          this.$confirm(mtype+' 리셋하시겠습니까?', '알림', {
      
          cancelButtonText: '취소',
              confirmButtonText: '리셋',
          type: 'warning'
        }).then(() => {
          // this.$parent.formLoading  = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/reset_money',
                      data:{
                      mem_id:this.form.mem_id,
                      type:type
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                    // this.$parent.formLoading  = false
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                      if(type==1)
                      {
                       this.form.mem_cash = '0'
                      }
                      else if(type==2)
                      {
                       this.form.mem_eventmoney='0'
                        
                        
                      }
                      else if(type==3)
                      {
                       this.form.mem_ing='0'
                      }
                      else if(type==4)
                      {
                       this.form.mem_all_init='0'
                      }
                      
                     
              
                      //this.$parent.getList()
                      
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: '취소됨'
          });          
        });

     
        },
        mlogout(){
          
                     


          this.$confirm(this.form.mem_id+' 아웃하시겠습니까?', '알림', {
      
              cancelButtonText: '취소',
              confirmButtonText: '아웃',
          type: 'warning'
        }).then(() => {
          // this.$parent.formLoading  = true
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/mem_out',
                      data:{
                      mem_id:this.form.mem_id
                      
                    },
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                         
                  }).then((response) =>{ 
                    // this.$parent.formLoading  = false
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })

                       this.form.loging='0'
                      
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message: '취소됨'
          });          
        });

     
        },
        
        handleClose() {
                this.$emit('handleClose')
            },

    	
    	}
	}
</script>
<style>
/deep/ .el-dialog__body{
  padding:5px 10px;
}
/deep/ .el-dialog__header{
  padding:2px 20px 10px
}
.flexNo{
  display: block;
}
.myflex{
  margin-left: -118px;
}

</style>


// WEBPACK FOOTER //
// src/components/common/id-dialog.vue